import "../src/global/global-pc"

import "@modules/vue-modals/ad-free"
import "@modules/vue-modals/age-verification"

import "@modules/location/LocationSelector"
import "@modules/solads/solads"
import "@modules/single-page/gallery/gallery.css"
import "@modules/stars/styles-pc.css"
import "@modules/stars/stars-post"
import "@modules/stars-profile/pc.css"
import "@modules/stars/upgraded-stars-slider.css"
import "@modules/tracking/previous-next-advert-cookie"
import "@modules/stars-profile/swiper-pc.ts"
import "@modules/stars/royal-slider.ts"
import { initGallery } from "../src/single-page/gallery/gallery.ts"

import "@modules/vue-modals/ad-free.js"
import "@modules/vue-modals/coins"
import "@modules/vue-modals/age-verification.js"

import StarsPost from "@modules/stars/stars-post/StarsPost"

const posts = new StarsPost(this)

posts.loadCurrentStarsPostsFilterForStarsProfile()
initGallery()
